import React from "react";
import { NavLink } from "react-router-dom";

interface Props {
  aiConfigId: string;
}

interface TabItem {
  label: string;
  path: string;
  disabled?: boolean;
}

export default function AINewSettingsTabs({ aiConfigId }: Props) {
  const tabs: TabItem[] = [
    { label: "General", path: `/ai-new/settings/general/${aiConfigId}` },
    { label: "Knowledge", path: `/ai-new/settings/knowledge/${aiConfigId}` },
    { label: "Test Your Bot", path: `/ai-new/settings/test-chat/${aiConfigId}` },
    { label: "Channel Overrides", path: `/ai-new/settings/channel-overrides/${aiConfigId}` },
    { label: "Handoff", path: `/ai-new/settings/handoff/${aiConfigId}` },
    { label: "Knowledge Overrides", path: `/ai-new/settings/knowledge-overrides/${aiConfigId}` },
    { label: "Suppressed Content", path: `/ai-new/settings/suppressed-content/${aiConfigId}` },
    { label: "Q&A Knowledge", path: `/ai-new/settings/qna/${aiConfigId}` },
    { label: "Skills", path: `/ai-new/settings/skills/${aiConfigId}` }
  ];

  // overflow-y-hidden is required: with only overflow-x-auto the browser promotes overflow-y
  // to `auto`, so the tabs' 1px -mb-px/border-b overflow renders a spurious vertical scrollbar
  // next to the horizontal one (QA Issue 06). Pinning y to hidden removes it; the single tab
  // row never needs vertical scroll.
  return (
    <div className="flex overflow-x-auto overflow-y-hidden">
      {tabs.map((tab) =>
        tab.disabled ? (
          <span
            key={tab.path}
            className="px-6 py-2.5 text-sm font-medium border-b-2 -mb-px border-transparent text-zinc-300 cursor-not-allowed whitespace-nowrap"
          >
            {tab.label}
          </span>
        ) : (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) =>
              `px-6 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap ${
                isActive
                  ? "border-[var(--color-primary)] text-[var(--color-primary)]"
                  : "border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300"
              }`
            }
          >
            {tab.label}
          </NavLink>
        )
      )}
    </div>
  );
}
